// src/api/productApi.js
import api from './index';
// 获取产品数据（通用方法，已有）
export const getAppProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_app_accounts', params);
};

// 获取 app1 产品库存
export const getApp1Products = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_app1_accounts', params);
};

// 获取 app3 产品库存
export const getApp3Products = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_app3_accounts', params);
};

// 获取 app6 产品库存
export const getApp6Products = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_app6_accounts', params);
};


// 获取产品数据（通用方法，已有）
export const getProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_google_001', params);
};


// 获取镜像站展示产品（用于首页展示的精选镜像产品）
export const getMirrorDisplayProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/getMirrorDisplayProducts_0527', params);
};


export const getAPPDisplayProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_0522', params);
};


export const getRenewDisplayProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_0522_renew', params);
};
// 获取成品号展示产品（用于首页展示的精选成品号）
export const getFinishedDisplayProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_google_001', params);
};

// 获取所有镜像站产品（完整镜像产品列表）
export const getAllMirrorProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/getAllMirrorProducts', params);
};

// 获取所有成品号产品（完整成品号列表）
export const getAllFinishedProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_google_001', params);
};

// 获取具体的产品详情（根据产品 ID）
export const getProductDetail = (productId, params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_detail_0523', {
    productId,
    ...params,
  });
};

// 新增：提交订单
export const submitOrder = (orderData) => api.post('/testapi/payment/payment_ali_hk_controller/get_product_pay_url_by_channel_by_aimonkey', orderData);

export const submitGuestOrder = (orderData) => api.post('/testapi/payment/payment_ali_hk_controller/get_product_pay_url_by_channel_by_aimonkey_guest', orderData);


export const checkOrderStatus = (out_trade_no) => api.post('/testapi/payment/payment_controller/check_order', { out_trade_no });

//新增 获取使用链接
export const getMonkeyUrl = (user_key) => api.post('/testapi/gateway/gateway_controller/get_aimonkey_login_by_token', { user_key });

// 获取未售出的有效期卡库存
export const getUnsoldCards = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_unsold_cards', params);
};
